import { Box, BoxProps, Flex } from 'reflexbox';
import styled from 'styled-components';
import { mix, rgba } from 'polished';

import { CheckmarkIcon } from '@treams/treams-icons';

const Container = styled(Box)<{ checked?: boolean }>`
	width: 24px;
	height: 24px;
	border: 2px solid ${(props) => props.theme.colors.lightBlueDark};
	border-radius: 12px;
	padding: 2px;

	&:focus {
		box-shadow: 0px 0px 0px 2px ${(props) => rgba(props.theme.colors.lightBlue, 0.25)};
	}

	svg {
		display: block;
		width: 16px;
		height: 16px;

		path {
			fill: white;
		}
	}

	${(props) =>
		props.checked &&
		`
		background: ${props.theme.colors.primary};
		border-color: ${props.theme.colors.primary};

		&:focus {
			box-shadow: 0px 0px 0px 2px ${rgba(props.theme.colors.primary, 0.25)};
		}
	`}
`;

export function Radio(props: BoxProps & { checked?: boolean; onChange: () => void }) {
	const { checked, onChange, ...rest } = props;

	return (
		<Container tabIndex={0} checked={checked} onClick={() => onChange()} {...rest}>
			{props.checked && <CheckmarkIcon />}
		</Container>
	);
}

const RadioCardContainer = styled(Flex)<{ checked?: boolean }>`
	background: white;
	border: 1px solid ${(props) => props.theme.colors.lightBlueLight};
	border-radius: 5px;
	cursor: pointer;

	${(props) =>
		props.checked
			? `
        background: ${rgba(props.theme.colors.primary, 0.1)};
        color: ${props.theme.colors.primary};
    `
			: `
        &:hover {
            background: ${mix(0.75, 'white', props.theme.colors.lightBlueLight)};

            &:active {
                background: ${mix(0.5, 'white', props.theme.colors.lightBlueLight)};
            }
        }
    `}
`;

function RadioCard(props: { checked?: boolean; onChange: () => void; title: string }) {
	return (
		<RadioCardContainer
			p={2}
			alignItems="center"
			onClick={() => props.onChange()}
			checked={props.checked}
		>
			<Box flexGrow={0} flexShrink={0} mr={2}>
				<Radio checked={props.checked} onChange={props.onChange} />
			</Box>
			<Box flexGrow={1} flexShrink={1}>
				{props.title}
			</Box>
		</RadioCardContainer>
	);
}

Radio.Card = RadioCard;
